module.exports = true;



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/modules/_library.js
// module id = 235
// module chunks = 0